import { Component } from 'react';
import { Flow } from 'flow-react';
import { observer } from "mobx-react"
import { Container, Row, Col} from 'react-bootstrap';
import './Singleview.css';

function diffWeek(rw) {
  if(typeof(rw) != 'string' || rw.length != 8)
      return false;
	return rw.substr(6);
}
function frenchDate(rd,rt) {
  if(typeof(rd) != 'string' || rd.length != 10)
      return false;
  let mois = ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre" ];
  let today = new Date(rd);
  let year = today.getFullYear();
  let dayNumber = today.getDate();
  let month = mois[today.getMonth()];
  let weekday = today.toLocaleDateString("fr-FR", { weekday: "long" });
  let fdate =  `${dayNumber} ${month} ${year}`;
  if(typeof(rt) == 'string')
     fdate += ' à ' + rt;
   return fdate;
}

const Singleview = observer(
  class Singleview extends Component {
						
		//hier sind alle chains ausser f3regional und "Réseau la 1ère" weil da jeweils die untericons angezeight werden
		chains = ["France 2","France 3","France 4","France 5","Outre-Mer la 1ère","france.tv distribution","france.tv","Lumni","france.tv Slash"]
		chacls = ["france_2","france_3","france_4","france_5","outre_mer_la_1ere","france_tv_distribution","france_tv","lumni","france_tv_slash"]
		
    regs = ["Auvergne Rhône-Alpes","Bourgogne Franche-Comté","Bretagne","Centre Val de Loire","Corse ViaStella","Grand-Est","Hauts de France","Normandie","Nouvelle Aquitaine","Occitanie","Paris Île-de-France","Pays de la Loire","Provence Alpes Côte d'Azur"]
		rcls = ["auvergne_rhone_alpes","bourgogne_franche_comte","bretagne","centre_val_de_loire","corse_viastella","grand_est","hauts_de_france","normandie","nouvelle_aquitaine","occitanie","paris_ile_de_france","pays_de_la_loire","provence_alpes_cote_d_azur"]
		
		stats = ["Guadeloupe","Guyane","La Réunion","Martinique","Mayotte","Nouvelle Calédonie","Polynésie","Saint-Pierre et Miquelon","Wallis et Futuna"]
		stcls = ["guadeloupe","guyane","la_reunion","martinique","mayotte","nouvelle_caledonie","polynesie","saint_pierre_et_miquelon","wallis_et_futuna"]
		
		lastreportedclid = 0;
		
		//txt3: chains - txt2: regs - txt21: stats

		getIconsForField = (f,m,c) => {
			let erg = [];
			if(typeof(f) != 'string')
				return erg;
			for(var e of f.split(';')) {
				if(m.indexOf(e) > -1)
					erg.push(c[m.indexOf(e)]);
			}
			return erg;
		}
		
		getIcons = (cl) => {
			let md = cl.data.metadata.fields;
			let icons = [];
			icons = icons.concat(this.getIconsForField(md.txt3,this.chains,this.chacls));
			icons = icons.concat(this.getIconsForField(md.txt2,this.regs,this.rcls));
			icons = icons.concat(this.getIconsForField(md.txt21,this.stats,this.stcls));
			return icons;
		}
			
		getThumb = (cl) => {
			let mt = cl.getMainthumbnail();
			if(mt != null)
				mt = mt.getUrl()+'&height=900&width=900&cache=1';
			else 
				mt = '';
			return mt;
		}
			
		getVideo = (cl) => {
			let mfs = cl.data.mediafiles.elements;
			for(var res of ['mp4_720p','mp4_540p','mp4_216p','preview']) {
				for(var mf of cl.data.mediafiles.elements) {
					if(typeof(mf.data.tags) == 'string' && mf.data.tags.indexOf(res) > -1)
						return mf.data.url;
				}
			}
			return false;
		}
		
		rightClick(e) {
			e.preventDefault()
			return false;
		}
		
		mklink(url) {
			if(typeof(url) != 'string' || url == '') return '';
			if(url.indexOf('http') != 0)
				url = 'https://'+url;
			return <a rel="noreferrer" target="_blank" href={url}>{url}</a>
		}
		
    render() {
			if(this.lastreportedclid != this.props.clip.id) {
				this.lastreportedclid = this.props.clip.id;
				this.props.flow.ftvfeInsertStat({'action':'clipview','clid':this.props.clip.id});
			}
			let cl = this.props.clip;
			let mt = this.getThumb(cl);
			let ic = this.getIcons(cl);
			let vi = this.getVideo(cl);
			let ti = cl.getMetadata().get('title');
			let md = cl.data.metadata.fields;
			let dd = frenchDate(md.txt6,md.txt7);
			let sd = diffWeek(md.txt17);
			return  (
				<>
					<Row>
						<Col sm={1} md={2} />
							<Col sm={10} md={8} xs={12} className="align-middle sglbacklinkcol" onClick={()=>{ this.props.clipclickcb(0) }} >
								Retour au résultat de recherche
							</Col>
						<Col sm={1} md={2} />
					</Row>
					<Row className="sgliconscol">
						<Col sm={1} md={2} />
							<Col sm={10} md={8} xs={12}>
								<Row>
									{ic.map(c => {return <Col xs={1} sm={1} key={c} className={'swicon sgw_'+c} />})}
									<Col>
									<Row><Col className="sgltitle">{cl.getMetadata().get('title')}</Col></Row>
									<Row><Col className="sglsubtitle">{cl.getMetadata().get('txt23')}</Col></Row>
									</Col>
								</Row>
							</Col>
						<Col sm={1} md={2} />
					</Row>
					<Row className="sglplayerrow">
						<Col sm={1} md={2} />
							<Col className="sglplayercol" sm={10} md={8} xs={12}>
								<video onContextMenu={(e) => this.rightClick(e)} controls controlsList="nodownload" src={vi} poster={mt} />
							</Col>
						<Col sm={1} md={2} />
					</Row>
					<Row>
						<Col sm={1} md={2} />
							<Col sm={10} md={8} xs={12} className="align-middle" >
								<Row>
									<Col xs={12} >{(dd) ? <b>Date de diffusion</b> : ''} {dd}</Col>
								</Row>
								<Row>
									<Col xs={12} sm={6}>{(sd) ? <b>Semaine de diffusion</b> : ''} {sd}</Col>
									<Col xs={0} sm={1}></Col>
									<Col xs={12} sm={5}></Col>
								</Row>
								<Row>
									<Col xs={12} sm={6}>{(md.txt12) ? <b>Zone de diffusion</b> : ''} {md.txt12}</Col>
									<Col xs={0} sm={1}></Col>
									<Col xs={12} sm={5}>{(md.txt8) ? <b>Contact presse</b> : ''} {md.txt8}</Col>
								</Row>
								<Row>
									<Col xs={12} sm={6}>{(md.txt4) ? <b>Genre</b> : ''} {md.txt4}</Col>
									<Col xs={0} sm={1}></Col>
									<Col xs={12} sm={5}>{(md.txt9) ? <b>Coordonnées</b> : ''} {md.txt9}</Col>
								</Row>
								<Row>
									<Col xs={12} sm={6}>{(md.txt5) ? <b>Description</b> : ''} {md.txt5}</Col>
									<Col xs={0} sm={1}></Col>
									<Col xs={12} sm={5}></Col>
								</Row>
								<Row>
									<Col xs={12} sm={6}>{(md.txt16) ? <b>Fiche technique</b> : ''} {md.txt16}</Col>
									<Col xs={0} sm={1}></Col>
									<Col xs={12} sm={5}>{(md.txt14) ? <b>Lien additionnel</b> : ''} {this.mklink(md.txt14)}</Col>
								</Row>
							</Col>
						<Col sm={1} md={2} />
					</Row>
					<Row>
						<Col className="h50" xs={12}/>
					</Row>
				</>
			)
    }
		
  }
)


export default Flow.injectFlow(Singleview);